import {useMemo} from 'react';
import {getCandidateSuggestionLabel} from '../selectors';

const useCandidateSuggestionLabels = fields => useMemo(() => fields.map(field => getCandidateSuggestionLabel(field)), [fields]);

export default useCandidateSuggestionLabels;
